module.exports = __webpack_public_path__ + "img/logo_play_store.04aea3bd.png";